import { Table } from 'primeng/table';
import { WoOrderService } from 'src/app/core/services/wo-order/wo-order.service';
import { BreadcrumbService } from '../../../../layout/topbar/app.breadcrumb.service';
import { NotificationsService } from '../../../../shared/notifications/notifications.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { TranslateConfigService } from  '../../../../core/services/translate-config.service';
import { UserTokenService } from '../../../../core/services/user-token.service';
import { Router } from '@angular/router';
import { WoOrderOutput } from 'src/app/features/wo-order/wo-order.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'wo-order-grid',
    templateUrl: './wo-order-grid.component.html',
    styleUrls: ['./wo-order-grid.component.scss'],
    providers: [ConfirmationService, MessageService],
    encapsulation: ViewEncapsulation.None
})
export class WoOrderGridComponent implements OnInit {

    public userId: string;
    public language: string = "pt-BR";
    public list: WoOrderOutput[] = [];
    public flUpdate: boolean = true;
    public pageMessage: string = "";
    public classBtnUpd: string = "p-button p-button-success p-m-1 mr-1";


    constructor(private orderService: WoOrderService,
                private router: Router,
                private notificationsService: NotificationsService,
                private confirmationService: ConfirmationService,
                private translateService: TranslateService,
                private translateConfigService: TranslateConfigService,
                private breadcrumbService: BreadcrumbService,
                private userTokenService: UserTokenService) { }

    ngOnInit(): void {

        this.language = this.translateConfigService.getLanguage();
        this.userId = this.userTokenService.getUserId();
       // this.flUpdate = this.userTokenService.hasPermissionArray(['SF_ADMIN, SF_SELLER, WO_ORDER_R, WO_ORDER_U']);

        if (this.flUpdate == false)
        {
            this.classBtnUpd = "p-button p-button-secondary p-m-1 mr-1";
        }

        this.getList();

        this.translate();

    }

     translate(){
        const sleep = (ms) => new Promise(r => setTimeout(r, ms));

        (async () => {
            await sleep(100);

            const labOrder = this.translateService.instant('label.order')+" ";
            const labService = this.translateService.instant('label.orderService')+" ";
            //const labServiceNew = " "+this.translateService.instant('label.order_service_new');
            this.breadcrumbService.setItems([{label: labOrder},{label: labService, routerLink: ['order-service']} ]);
            this.pageMessage = this.translateService.instant('grid.showing')+" {first} "+this.translateService.instant('grid.to')+" {last} "+this.translateService.instant('grid.of')+" {totalRecords} "+this.translateService.instant('grid.entries')
        })();
    }

    newService(type: string){

    }

    clear(table: Table, filter: any) {
        table.clear();
        filter.Text = "";
    }

    getList() {
        this.orderService.getList().subscribe(
        {
            next: (res) => {
                if (res)
                    this.list = res.data;
            },
            error: (err) => {
                this.notificationsService.toastNotify('warn', this.translateService.instant('title.sc_company'), this.translateService.instant('api_response.ERROR'));
                console.log(`WoOrderGrid - getList : ${err}.`);
            }
        });
    }


  addItem() {
    this.router.navigate(['order-service-detail/', "0"]);
  }


  updItem(itemId: string) {
    this.router.navigate(['order-service-detail/', itemId]);
  }

}


